import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import { useEventListener } from '@beef/react';
import { calculateNodeHeight, createHiddenNode, getSizingData } from "./utils";
export var useTextAreaSize = function useTextAreaSize(params) {
  var maxRows = params.maxRows,
    onChangeProp = params.onChange,
    value = params.value;
  var _useState = useState(28),
    _useState2 = _slicedToArray(_useState, 2),
    inputHeight = _useState2[0],
    setInputHeight = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    rows = _useState4[0],
    setRows = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    overflowFlag = _useState6[0],
    setOverflowFlag = _useState6[1];
  var heightRef = useRef(0);
  var textAreaRef = useRef(null);
  var hiddenNodeRef = useRef(null);
  var resize = function resize() {
    var _textAreaRef$current, _textAreaRef$current2;
    var nodeSizingData = getSizingData(textAreaRef.current);
    if (!nodeSizingData) {
      return;
    }
    var hiddenNode = !hiddenNodeRef.current ? createHiddenNode(textAreaRef) : hiddenNodeRef.current;
    if (!hiddenNodeRef.current) {
      hiddenNodeRef.current = hiddenNode;
    }
    var _calculateNodeHeight = calculateNodeHeight(hiddenNode, nodeSizingData, ((_textAreaRef$current = textAreaRef.current) === null || _textAreaRef$current === void 0 ? void 0 : _textAreaRef$current.value) || ((_textAreaRef$current2 = textAreaRef.current) === null || _textAreaRef$current2 === void 0 ? void 0 : _textAreaRef$current2.placeholder) || 'x', maxRows),
      height = _calculateNodeHeight.height,
      isOverflow = _calculateNodeHeight.isOverflow,
      rowsCount = _calculateNodeHeight.rows;
    setRows(rowsCount);
    setOverflowFlag(isOverflow);

    // Необходимо, так как из-за бордеров при равной высоте появляется скролл
    if (isOverflow) {
      var _textAreaRef$current3;
      (_textAreaRef$current3 = textAreaRef.current) === null || _textAreaRef$current3 === void 0 ? void 0 : _textAreaRef$current3.style.removeProperty('overflow');
    } else {
      var _textAreaRef$current4;
      (_textAreaRef$current4 = textAreaRef.current) === null || _textAreaRef$current4 === void 0 ? void 0 : _textAreaRef$current4.style.setProperty('overflow', 'hidden', 'important');
    }
    if (heightRef.current !== height) {
      heightRef.current = height;
      setInputHeight(height);
    }
  };
  var onChange = function onChange(e) {
    if (value === undefined) {
      resize();
    }
    onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(e.target.value, e);
  };
  useEffect(resize, [textAreaRef, maxRows, value, rows]);
  useEventListener('resize', resize);
  return {
    textAreaRef: textAreaRef,
    onChange: onChange,
    inputHeight: inputHeight,
    rows: rows,
    overflowFlag: overflowFlag
  };
};